import { ReactNode } from 'react';

import OverflowContainer from '../OverflowContainer';

interface Props<R> {
  data: R[];
  onClick?: (item: R) => void;
  keyExtractor: (item: R) => string;
  renderItem: (record: R) => ReactNode;
}

/**
 * TODO: Mostrar botones de navegación cuando sea necesario.
 */
const Selector = <T = unknown,>({ data, onClick, keyExtractor, renderItem }: Props<T>) => {
  return (
    <div>
      <OverflowContainer>
        {data.map((item) => {
          return (
            <div
              key={keyExtractor(item)}
              onClick={() => {
                onClick?.(item);
              }}
            >
              {renderItem(item)}
            </div>
          );
        })}
      </OverflowContainer>
    </div>
  );
};

export default Selector;
